/*
 * bmfr-calendrier.js — page /pages/calendrier de bhaktimarga.fr
 *
 * Les événements sont injectés par la section « custom liquid » du template
 * templates/page.calendar.json, dans <script id="bmfr-cal-data" type="application/json">.
 * Chaque entrée vient d'un produit de la collection « evenements » :
 *   { titre, debut, fin, url, type, image, extrait }
 * debut / fin sont les métachamps event.start_date / event.end_date, en UTC.
 *
 * Deux rendus : l'agenda (fiches groupées par mois, vue par défaut) et la grille du mois
 * (FullCalendar, déjà chargé par le thème — la bascule disparaît s'il est absent).
 *
 * Toutes les dates sont raisonnées en heure de Paris. Deux cas de figure cohabitent dans
 * les données : les événements saisis à la main dans Shopify portent des bornes de
 * « journée entière » (00:00Z → 23:59Z) qu'il faut lire comme des dates nues, et ceux
 * créés depuis l'extranet portent une heure réelle convertie en UTC.
 */
(function () {
  'use strict';

  var socle = document.getElementById('bmfr-cal');
  var source = document.getElementById('bmfr-cal-data');
  if (!socle || !source) return;

  var MOIS_COURT = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin',
                    'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var MOIS_LONG = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                   'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

  // Couleur par famille d'événement (recherche par mot-clé : le type Shopify est libre).
  var COULEURS = [
    ['retraite', '#a97a25'], ['immersion', '#a97a25'], ['pèlerinage', '#8a6d3b'], ['pelerinage', '#8a6d3b'],
    ['festival', '#c2410c'], ['satsang', '#6b4f9c'], ['conférence', '#6b4f9c'], ['conference', '#6b4f9c'],
    ['cours', '#2c6ba0'], ['ligne', '#2c6ba0'], ['atelier', '#2f7d63'], ['sangha', '#b5563c'],
    ['yoga', '#1f7a8c'], ['méditation', '#1f7a8c'], ['meditation', '#1f7a8c'],
    ['rituel', '#9d3d6b'], ['meeting', '#5b6472'], ['réunion', '#5b6472'], ['reunion', '#5b6472']
  ];

  function sansAccent(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function couleur(type) {
    var t = (type || '').toLowerCase();
    for (var i = 0; i < COULEURS.length; i++) {
      if (t.indexOf(COULEURS[i][0]) !== -1) return COULEURS[i][1];
    }
    return '#16254c';
  }

  // ------------------------------------------------------------------ titres
  // Les titres répètent la date de l'événement (« … — 13 septembre 2026 »), déjà affichée
  // par la fiche : on la retire pour que le titre reste lisible.
  var MOIS_RE = '(?:janvier|f[eé]vrier|mars|avril|mai|juin|juillet|ao[uû]t|septembre|octobre|novembre|d[eé]cembre)';

  function nettoieTitre(titre) {
    var t = (titre || '').trim();
    var motifs = [
      // « du 21 octobre au 30 novembre 2026 », « 15 au 22 novembre 2026 », « 26 et 27 septembre 2026 »
      new RegExp('(?:du\\s+|le\\s+)?\\d{1,2}(?:\\s*(?:er)?)?\\s*(?:' + MOIS_RE + ')?\\s*(?:au|et|[-–—])\\s*\\d{1,2}\\s*(?:er)?\\s*' + MOIS_RE + '\\s*(?:20\\d{2})?\\s*$', 'i'),
      // « 13 septembre 2026 », « le 16 septembre 2026 »
      new RegExp('(?:du\\s+|le\\s+)?\\d{1,2}\\s*(?:er)?\\s*' + MOIS_RE + '\\s*(?:20\\d{2})?\\s*$', 'i'),
      // reste d'amorce une fois la date ôtée : « — démarrage », « , Lanzarote » garde le lieu
      /(?:d[eé]marrage|d[eè]s|à\s+partir\s+du?|le)\s*$/i,
      // séparateurs et ponctuation en fin de chaîne
      /[\s,;:.\u2013\u2014•|/-]+$/
    ];
    for (var passe = 0; passe < 4; passe++) {
      var avant = t;
      motifs.forEach(function (re) { t = t.replace(re, ''); });
      if (t === avant) break;
    }
    return t.trim() || (titre || '').trim();
  }

  /** Découpe « Titre — précision — précision » en titre + sous-titre. */
  function decoupeTitre(titre) {
    var bouts = nettoieTitre(titre).split(/\s+[\u2013\u2014]\s+/);
    return {
      titre: bouts.shift(),
      sous: bouts.join(' · ')
    };
  }

  // ------------------------------------------------------------------ dates

  /** Bornes de « journée entière » telles que saisies dans l'admin Shopify. */
  function estJourneeEntiere(debut, fin) {
    if (!/T00:00(:00)?/.test(debut)) return false;
    return !fin || /T(?:23:59|00:00)(:00)?/.test(fin);
  }

  var PARTIES = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
  });

  /** { a, m, j, h, min, jourSemaine } en heure de Paris (ou date nue si journée entière). */
  function parties(iso, journee) {
    if (journee) {
      var n = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!n) return null;
      var d = new Date(Date.UTC(+n[1], +n[2] - 1, +n[3], 12));
      return { a: +n[1], m: +n[2], j: +n[3], h: null, min: null, jourSemaine: d.getUTCDay() };
    }
    var dt = new Date(iso);
    if (isNaN(dt)) return null;
    var p = {};
    PARTIES.formatToParts(dt).forEach(function (x) { p[x.type] = x.value; });
    var jsem = new Intl.DateTimeFormat('en', { timeZone: 'Europe/Paris', weekday: 'short' }).format(dt);
    return {
      a: +p.year, m: +p.month, j: +p.day, h: +p.hour, min: +p.minute,
      jourSemaine: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(jsem)
    };
  }

  function heure(p) {
    if (p.h === null) return '';
    return p.min ? p.h + 'h' + String(p.min).padStart(2, '0') : p.h + 'h';
  }

  function memeJour(a, b) { return b && a.a === b.a && a.m === b.m && a.j === b.j; }

  /** « YYYY-MM-DD » à partir des parties : sert de position dans la grille du mois. */
  function cle(p) {
    return p.a + '-' + String(p.m).padStart(2, '0') + '-' + String(p.j).padStart(2, '0');
  }

  // ------------------------------------------------------------------ données

  var brut;
  try { brut = JSON.parse(source.textContent || '[]'); } catch (e) { brut = []; }

  var maintenant = new Date();
  var evenements = [];

  brut.forEach(function (e) {
    if (!e || !e.debut) return;
    var journee = estJourneeEntiere(e.debut, e.fin);
    var d = parties(e.debut, journee);
    if (!d) return;
    var f = e.fin ? parties(e.fin, journee) : null;
    if (f && (f.a < d.a || (f.a === d.a && f.m === d.m && f.j < d.j))) f = null;

    var nom = decoupeTitre(e.titre);
    evenements.push({
      titre: nom.titre,
      sous: nom.sous,
      brut: e.titre,
      url: e.url,
      type: (e.type || '').trim(),
      image: e.image || '',
      extrait: e.extrait || '',
      c: couleur(e.type),
      journee: journee,
      d: d,
      f: f,
      plage: !!f && !memeJour(d, f),
      // Fin réelle de l'événement : sert à savoir s'il est encore à venir.
      fin: new Date(e.fin || e.debut)
    });
  });

  evenements.sort(function (a, b) { return cle(a.d) < cle(b.d) ? -1 : cle(a.d) > cle(b.d) ? 1 : 0; });
  // Repère stable : les titres de l'agenda et les pastilles du mois s'y réfèrent pour
  // retrouver l'événement à montrer au survol.
  evenements.forEach(function (e, i) { e.i = i; });

  var aVenir = evenements.filter(function (e) { return e.fin >= maintenant; });
  var passes = evenements.filter(function (e) { return e.fin < maintenant; }).reverse();

  // ------------------------------------------------------------------ séries
  // Un rendez-vous récurrent (cours hebdomadaire, satsang mensuel) existe dans Shopify
  // sous forme d'une fiche par séance : une trentaine de fiches identiques noieraient
  // l'agenda. On n'en montre qu'une, qui annonce la prochaine séance et le rythme.
  // La grille du mois, elle, garde bien chaque séance à sa date.

  /** « chaque mercredi », « une fois par mois », ou rien si le rythme est irrégulier. */
  function rythme(serie) {
    if (serie.length < 3) return '';
    var jours = serie.map(function (e) { return Date.UTC(e.d.a, e.d.m - 1, e.d.j); });
    var ecarts = [];
    for (var i = 1; i < jours.length; i++) ecarts.push(Math.round((jours[i] - jours[i - 1]) / 86400000));
    var tous = function (test) { return ecarts.every(test); };
    if (tous(function (x) { return x === 7; })) return 'chaque ' + JOURS[serie[0].d.jourSemaine];
    if (tous(function (x) { return x === 14; })) return 'un ' + JOURS[serie[0].d.jourSemaine] + ' sur deux';
    if (tous(function (x) { return x >= 27 && x <= 31; })) return 'une fois par mois';
    return '';
  }

  function regroupeSeries(liste, aVenirFlag) {
    var paquets = {};
    var ordre = [];
    liste.forEach(function (e) {
      var k = e.type + '\u0000' + e.titre + '\u0000' + e.sous;
      if (!paquets[k]) { paquets[k] = []; ordre.push(k); }
      paquets[k].push(e);
    });

    var sortie = [];
    ordre.forEach(function (k) {
      var serie = paquets[k];
      // Deux séances seulement : autant les laisser apparaître séparément.
      if (serie.length < 3) { sortie = sortie.concat(serie); return; }
      var tete = {};
      Object.keys(serie[0]).forEach(function (p) { tete[p] = serie[0][p]; });
      tete.serie = serie;
      tete.rythme = rythme(serie);
      tete.prochaine = !!aVenirFlag;
      sortie.push(tete);
    });
    sortie.sort(function (a, b) { return cle(a.d) < cle(b.d) ? -1 : cle(a.d) > cle(b.d) ? 1 : 0; });
    return sortie;
  }

  // ------------------------------------------------------------------ rendu d'une fiche

  var ICONES = {
    horloge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    calendrier: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/></svg>',
    repete: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 2l4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/></svg>'
  };

  /** « chaque mercredi, jusqu'au 7 avril 2027 · 29 séances » */
  function texteSerie(e) {
    var dernier = e.serie[e.serie.length - 1];
    var jusqu = 'jusqu\'au ' + dernier.d.j + ' ' + MOIS_LONG[dernier.d.m - 1] + ' ' + dernier.d.a;
    return (e.rythme ? e.rythme + ', ' : '') + jusqu + ' · ' + e.serie.length + ' séances';
  }

  function texteQuand(e) {
    if (!e.plage) {
      var t = JOURS[e.d.jourSemaine] + ' ' + e.d.j + ' ' + MOIS_LONG[e.d.m - 1] + ' ' + e.d.a;
      if (e.d.h !== null) {
        t += ' · ' + heure(e.d) + (e.f && !e.journee ? ' → ' + heure(e.f) : '');
      }
      return t;
    }
    var deb = e.d.j + (e.d.m === e.f.m && e.d.a === e.f.a ? '' : ' ' + MOIS_LONG[e.d.m - 1]);
    var t2 = 'du ' + deb + ' au ' + e.f.j + ' ' + MOIS_LONG[e.f.m - 1] + ' ' + e.f.a;
    if (e.d.h !== null) t2 += ' · ' + heure(e.d) + (e.f.h !== null ? ' → ' + heure(e.f) : '');
    return t2;
  }

  function blocDate(e) {
    if (!e.plage) {
      return '<span class="bmfr-ev__jour">' + e.d.j + '</span>' +
             '<span class="bmfr-ev__moisjour">' + MOIS_COURT[e.d.m - 1] + '</span>' +
             '<span class="bmfr-ev__semaine">' + JOURS[e.d.jourSemaine] + '</span>';
    }
    var memeMois = e.d.m === e.f.m && e.d.a === e.f.a;
    return '<span class="bmfr-ev__jour bmfr-ev__jour--plage">' + e.d.j + '<span aria-hidden="true"> → </span>' + e.f.j + '</span>' +
           '<span class="bmfr-ev__moisjour">' +
             (memeMois ? MOIS_COURT[e.d.m - 1] : MOIS_COURT[e.d.m - 1] + ' – ' + MOIS_COURT[e.f.m - 1]) +
           '</span>';
  }

  function fiche(e) {
    var a = document.createElement('a');
    a.className = 'bmfr-ev';
    a.href = e.url;
    a.style.setProperty('--c', e.c);

    var affiche = e.image
      ? '<div class="bmfr-ev__affiche"><img src="' + e.image + '" alt="Affiche : ' + echappe(e.brut) + '" loading="lazy" width="300" height="400"></div>'
      : '<div class="bmfr-ev__affiche bmfr-ev__affiche--vide">॥</div>';

    a.innerHTML =
      '<div class="bmfr-ev__date">' + blocDate(e) + '</div>' +
      affiche +
      '<div class="bmfr-ev__corps">' +
        (e.type ? '<span class="bmfr-ev__type">' + echappe(e.type) + '</span>' : '') +
        '<h3 class="bmfr-ev__titre" data-ev="' + e.i + '">' + echappe(e.titre) + '</h3>' +
        (e.sous ? '<p class="bmfr-ev__sous">' + echappe(e.sous) + '</p>' : '') +
        '<p class="bmfr-ev__infos"><span>' +
          (e.plage ? ICONES.calendrier : ICONES.horloge) +
          echappe((e.prochaine ? 'Prochaine séance : ' : '') + texteQuand(e)) +
        '</span>' +
        (e.serie ? '<span>' + ICONES.repete + echappe(texteSerie(e)) + '</span>' : '') +
        '</p>' +
        (e.extrait ? '<p class="bmfr-ev__extrait">' + echappe(e.extrait) + '</p>' : '') +
        '<span class="bmfr-ev__lien">Voir le programme</span>' +
      '</div>';
    // La carte de survol lit l'événement ici : une tête de série n'existe pas dans la
    // liste brute, elle ne peut donc pas être retrouvée par son seul indice.
    a.querySelector('.bmfr-ev__titre')._ev = e;
    return a;
  }

  function echappe(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ------------------------------------------------------------------ agenda

  var zoneAgenda = document.getElementById('bmfr-cal-agenda');

  function rendAgenda(liste, listePassee) {
    zoneAgenda.textContent = '';

    if (!liste.length) {
      var vide = document.createElement('p');
      vide.className = 'bmfr-cal__vide';
      vide.textContent = 'Aucun événement à venir dans cette catégorie pour le moment.';
      zoneAgenda.appendChild(vide);
    }

    var moisCourant = '';
    var groupe = null;
    liste.forEach(function (e) {
      var m = e.d.a + '-' + e.d.m;
      if (m !== moisCourant) {
        moisCourant = m;
        groupe = document.createElement('section');
        groupe.className = 'bmfr-cal__groupe';
        var h = document.createElement('h2');
        h.className = 'bmfr-cal__mois';
        h.textContent = MOIS_LONG[e.d.m - 1] + ' ' + e.d.a;
        groupe.appendChild(h);
        zoneAgenda.appendChild(groupe);
      }
      groupe.appendChild(fiche(e));
    });

    if (listePassee.length) {
      var det = document.createElement('details');
      det.className = 'bmfr-cal__passes';
      var som = document.createElement('summary');
      som.textContent = listePassee.length + ' événement' + (listePassee.length > 1 ? 's' : '') + ' passé' + (listePassee.length > 1 ? 's' : '');
      det.appendChild(som);
      listePassee.forEach(function (e) { det.appendChild(fiche(e)); });
      zoneAgenda.appendChild(det);
    }
  }

  // ------------------------------------------------------------------ filtres par type

  var typeActif = '';
  var types = [];
  aVenir.forEach(function (e) {
    if (e.type && types.indexOf(e.type) === -1) types.push(e.type);
  });
  types.sort(function (a, b) { return sansAccent(a) < sansAccent(b) ? -1 : 1; });

  var zoneFiltres = document.getElementById('bmfr-cal-filtres');

  function construitFiltres() {
    if (!zoneFiltres || types.length < 2) return;
    var boutons = [{ val: '', nom: 'Tout' }].concat(types.map(function (t) { return { val: t, nom: t }; }));
    boutons.forEach(function (b) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bmfr-cal__filtre';
      btn.setAttribute('aria-pressed', b.val === typeActif ? 'true' : 'false');
      btn.dataset.type = b.val;
      if (b.val) {
        btn.style.setProperty('--c', couleur(b.val));
        btn.innerHTML = '<span class="bmfr-cal__pastille"></span>' + echappe(b.nom);
      } else {
        btn.textContent = b.nom;
      }
      btn.addEventListener('click', function () {
        typeActif = b.val;
        zoneFiltres.querySelectorAll('.bmfr-cal__filtre').forEach(function (x) {
          x.setAttribute('aria-pressed', x.dataset.type === typeActif ? 'true' : 'false');
        });
        applique();
      });
      zoneFiltres.appendChild(btn);
    });
  }

  function filtre(liste) {
    return typeActif ? liste.filter(function (e) { return e.type === typeActif; }) : liste;
  }

  // ------------------------------------------------------------------ vue mois (FullCalendar)

  var grille = null;
  var zoneMois = document.getElementById('bmfr-cal-mois');

  function pourFullCalendar(liste) {
    return liste.map(function (e) {
      // Tous les événements sont posés en « journée entière » sur les dates de Paris :
      // la grille reste juste quel que soit le fuseau du visiteur. L'heure affichée dans
      // la pastille est calculée à part, en heure de Paris.
      var finExclusive = new Date(Date.UTC(
        (e.f || e.d).a, (e.f || e.d).m - 1, (e.f || e.d).j + 1, 12));
      return {
        title: e.titre,
        start: cle(e.d),
        end: finExclusive.toISOString().slice(0, 10),
        allDay: true,
        url: e.url,
        extendedProps: { c: e.c, h: e.d.h !== null ? heure(e.d) : '', type: e.type, i: e.i }
      };
    });
  }

  function construitMois() {
    if (grille || typeof FullCalendar === 'undefined') return;
    var hote = document.getElementById('calendar');
    if (!hote) return;

    grille = new FullCalendar.Calendar(hote, {
      initialView: 'dayGridMonth',
      locale: 'fr',
      firstDay: 1,
      height: 'auto',
      initialDate: (aVenir[0] || evenements[0] || { d: null }).d
        ? cle((aVenir[0] || evenements[0]).d) : undefined,
      headerToolbar: { left: 'prev,next', center: 'title', right: 'today' },
      buttonText: { today: "Aujourd'hui" },
      dayMaxEvents: 3,
      moreLinkText: function (n) { return '+ ' + n + ' autre' + (n > 1 ? 's' : ''); },
      displayEventTime: false,
      events: pourFullCalendar(filtre(evenements)),
      eventContent: function (arg) {
        var el = document.createElement('div');
        el.className = 'bmfr-pill';
        el.style.setProperty('--c', arg.event.extendedProps.c);
        el.dataset.ev = arg.event.extendedProps.i;
        var h = arg.event.extendedProps.h;
        el.innerHTML = (h ? '<span class="bmfr-pill__h">' + h + '</span>' : '') +
                       '<span class="bmfr-pill__t">' + echappe(arg.event.title) + '</span>';
        return { domNodes: [el] };
      },
      eventClick: function (info) {
        if (info.event.url) { info.jsEvent.preventDefault(); window.location.href = info.event.url; }
      }
    });
    grille.render();
  }

  function majMois() {
    if (!grille) return;
    grille.removeAllEventSources();
    grille.addEventSource(pourFullCalendar(filtre(evenements)));
  }

  // ------------------------------------------------------------------ carte de survol
  // Survoler un titre (agenda) ou une pastille (vue mois) montre l'affiche et le début de
  // la description. Purement indicatif : tout est déjà accessible au clic.

  var carte = null;
  var attente = null;
  var survole = null;

  function creeCarte() {
    if (carte) return carte;
    carte = document.createElement('div');
    carte.className = 'bmfr-carte';
    carte.setAttribute('aria-hidden', 'true');
    document.body.appendChild(carte);
    return carte;
  }

  function remplitCarte(e) {
    var c = creeCarte();
    c.style.setProperty('--c', e.c);
    c.innerHTML =
      (e.image
        ? '<div class="bmfr-carte__affiche"><img src="' + e.image + '" alt="" width="240" height="320"></div>'
        : '<div class="bmfr-carte__affiche"></div>') +
      '<div>' +
        (e.type ? '<span class="bmfr-carte__type">' + echappe(e.type) + '</span>' : '') +
        '<p class="bmfr-carte__titre">' + echappe(e.titre) + (e.sous ? ' <span style="font-weight:400">— ' + echappe(e.sous) + '</span>' : '') + '</p>' +
        '<p class="bmfr-carte__quand">' + echappe(texteQuand(e)) +
          (e.serie ? '<br>' + echappe(texteSerie(e)) : '') + '</p>' +
        (e.extrait ? '<p class="bmfr-carte__texte">' + echappe(e.extrait) + '</p>' : '') +
        '<p class="bmfr-carte__pied">Voir le programme →</p>' +
      '</div>';
    return c;
  }

  function placeCarte(cible) {
    var r = cible.getBoundingClientRect();
    var vueL = document.documentElement.clientWidth;
    var l = carte.offsetWidth;
    var h = carte.offsetHeight;

    var x = Math.min(r.left, vueL - l - 12);
    x = Math.max(12, x);

    // Sous la cible par défaut, au-dessus s'il n'y a pas la place en bas de fenêtre.
    var y = r.bottom + 10;
    if (y + h > window.innerHeight - 8) y = Math.max(8, r.top - h - 10);

    carte.style.left = (x + window.scrollX) + 'px';
    carte.style.top = (y + window.scrollY) + 'px';
  }

  function ouvreCarte(cible) {
    var e = cible._ev || evenements[+cible.dataset.ev];
    if (!e) return;
    survole = cible;
    remplitCarte(e);
    carte.dataset.ouverte = 'false';
    placeCarte(cible);           // mesurable : la carte occupe déjà sa place, seule l'opacité change
    carte.dataset.ouverte = 'true';
  }

  function fermeCarte() {
    clearTimeout(attente);
    survole = null;
    if (carte) carte.dataset.ouverte = 'false';
  }

  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (ev) {
      var cible = ev.target.closest ? ev.target.closest('[data-ev]') : null;
      if (!cible || cible === survole) return;
      clearTimeout(attente);
      attente = setTimeout(function () { ouvreCarte(cible); }, 140);
    });

    document.addEventListener('mouseout', function (ev) {
      var cible = ev.target.closest ? ev.target.closest('[data-ev]') : null;
      if (cible && cible === survole) fermeCarte();
      else if (cible) clearTimeout(attente);
    });

    window.addEventListener('scroll', fermeCarte, { passive: true });
    window.addEventListener('resize', fermeCarte);
  }

  // ------------------------------------------------------------------ bascule des vues

  var vues = socle.querySelectorAll('.bmfr-cal__vue');

  function montre(nom) {
    fermeCarte();
    vues.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.vue === nom ? 'true' : 'false'); });
    zoneAgenda.hidden = nom !== 'agenda';
    if (zoneMois) zoneMois.hidden = nom !== 'mois';
    if (nom === 'mois') {
      construitMois();
      if (grille) grille.updateSize();
    }
  }

  vues.forEach(function (b) {
    b.addEventListener('click', function () { montre(b.dataset.vue); });
  });

  // La grille du mois n'existe que si le thème a bien chargé FullCalendar.
  if (typeof FullCalendar === 'undefined') {
    vues.forEach(function (b) { if (b.dataset.vue === 'mois') b.remove(); });
    if (zoneMois) zoneMois.remove();
  }

  function applique() {
    fermeCarte();   // les fiches survolées sont recréées à chaque filtrage
    rendAgenda(
      regroupeSeries(filtre(aVenir), true),
      regroupeSeries(filtre(passes), false).reverse()   // les passés, du plus récent au plus ancien
    );
    majMois();
  }

  construitFiltres();
  applique();
  montre('agenda');
})();
